import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    anio: number = new Date().getFullYear();
  get usuarioRol(): string {
    try {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      return currentUser?.role ?? '';
    } catch {
      return '';
    }
  }

  ngOnInit(): void {}

  get whatsappUrl(): string {
    const msg = encodeURIComponent('Hola, vengo de TG Empleos.\nPágina: ' + window.location.href);
    return 'https://api.whatsapp.com/send?phone=525561868835&text=' + msg;
  }

}
